'use strict';

const Mn = require('backbone.marionette');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const AdminCoverView = require('feedback/ui/view/admin/common/cover');
const CommentView = require('feedback/ui/view/idea/comment');
const Template = require('feedback/ui/template/admin/idea/detail.hbs');
const RelatedURLsTemplate = require('feedback/ui/template/admin/idea/related-urls.hbs');
const Marked = require('balus/util/marked');
const IdeaRepository = require('feedback/domain/repository/idea');

const RelatedURLsItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: RelatedURLsTemplate
});

const RelatedURLsListView = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: RelatedURLsItemView
});

/**
 /**
 * ユーザからの要望を詳しく表示する View
 * (要望詳細、コメント一覧、コメント投稿フォームを内包する)
 */
module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'row',
    template: Template,
    regions: {
        sidebar: '#sidebar',
        cover: '#cover',
        relatedURLs: '.related-urls'
    },
    modelEvents: {
        'change': 'render'
    },

    initialize: function() {
        IdeaRepository.fetchCommentsByIdea(this.model);
        this.relatedURLs = new Backbone.Collection();
        this.listenTo(this.model.comments, 'add reset', this.render);
    },

    templateContext: function() {
        return {
            isPublic: this.model.isPublic(),
            body: Marked()(this.model.getBody()),
            stateColor: this.model.getState().color,
            commentNum: this.model.comments.length,
            summary: Marked()(this.model.getSummary() ? this.model.getSummary() : '')
        };
    },

    onRender: function() {
        _.each(this.model.getRelatedURLs(), url => {
            this.relatedURLs.add(new Backbone.Model({url: url}));
        });
        this.showChildView('relatedURLs', new RelatedURLsListView({
            collection: this.relatedURLs
        }));
    },

    onDomRefresh: function() {
        this.showChildView('cover', new AdminCoverView({isIdea: true}));

        const navs = new SidebarCollection(
            [
                {
                    name: 'comment',
                    icon: 'fa fa-comments-o',
                    label: 'module/word:comment',
                    view: new CommentView({
                        model: this.model,
                        collection: this.model.comments
                    }),
                    open: true
                },
            ]
        );

        this.showChildView('sidebar', new SidebarView({
            navs: navs,
            horizontalNav: true
        }));

        $.material.init();
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/idea/detail.js